// App-level CRM provider stack. Mounted once above the router so an in-progress
// browser call survives navigating out of /crm/preview into another TG module.
// Everything ActiveCallProvider transitively needs (QueryClient for crmApi
// queries, theme tokens for the floating widget, selected project for any
// project-scoped re-renders) is hoisted along with it.
//
// ReminderOverlay is intentionally NOT hoisted — it polls every 60s and
// only makes sense while the user is inside the CRM shell.

import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { CrmThemeProvider } from "./theme/ThemeProvider";
import { crmQueryClient } from "./api/queryClient";
import { ActiveCallProvider } from "./contexts/ActiveCallProvider";
import { SelectedCompanyProvider } from "./contexts/SelectedCompanyProvider";
import { SelectedProjectProvider } from "./contexts/SelectedProjectProvider";
import { CrmFirstRunProvider } from "./contexts/CrmFirstRunContext";

export default function CrmGlobalProviders({ children }) {
  return (
    <QueryClientProvider client={crmQueryClient}>
      <CrmThemeProvider>
        <SelectedCompanyProvider>
          <CrmFirstRunProvider>
            <SelectedProjectProvider>
              <ActiveCallProvider>
                {children}
                <Toaster position="top-right" containerStyle={{ zIndex: 100000 }} />
              </ActiveCallProvider>
            </SelectedProjectProvider>
          </CrmFirstRunProvider>
        </SelectedCompanyProvider>
      </CrmThemeProvider>
    </QueryClientProvider>
  );
}
